/**
 * Helix
 */
export const Helix = ({ startAngle = 0, endAngle = Math.PI * 6, innerRadius = 0, outerRadius = 1, }) => [
    ['translate', 0.5, 0.5],
    ['reflect.y'],
    ['translate', -0.5, -0.5],
    ['helix', startAngle, endAngle, innerRadius, outerRadius],
];
Helix.props = {};
//# sourceMappingURL=helix.js.map